import BillingHTTP from 'utils/billing-http';

class ContactService {
  resendEmailConfirmation(emailId) {
    return BillingHTTP.postContent(`/dashboard-api/v2/emails/${emailId}/resend-confirmation`);
  }
}

export default new ContactService();
